import React, { Fragment, lazy, Suspense } from "react";
import PropTypes from "prop-types";
import ExecutionEnvironment from "exenv";

// Components
import CustomMeta from "../components/CustomMeta/CustomMeta";
const LoginOrSignup = React.lazy(() =>
  import(
    /* webpackChunkName: "LoginOrSignup" */ "../components/Login/LoginOrSignup"
  )
);
const ProductsTable = React.lazy(() =>
  import(
    /* webpackChunkName: "ProductsTable" */ "../components/Products/ProductsTable"
  )
);
const ConnectedShops = React.lazy(() =>
  import(
    /* webpackChunkName: "ConnectedShops" */ "../components/Products/ConnectedShops"
  )
);
const AddEtsyStore = React.lazy(() =>
  import(
    /* webpackChunkName: "AddEtsyStore" */ "../components/Products/AddEtsyStore"
  )
);

const AddWoocommerceStore = React.lazy(() =>
  import(
    /* webpackChunkName: "AddWoocommerceStore" */ "../components/Products/AddWoocommerceStore"
  )
);
import UploadProductsViaCSV from "../components/Products/UploadProductsViaCSV";

import { makeStyles } from "tss-react/mui";
import { Typography, Paper, CircularProgress, Grid } from "@mui/material";

// redux stuff
import { connect } from "react-redux";
import { getAffiliateData } from "../redux/actions/dataActions";

const useStyles = makeStyles()((theme) => ({
  fullPageHeight: {
    minHeight: "100vh",
    width: "100%",
  },
  root: {
    flexGrow: 1,
    padding: 16,
    maxWidth: "100%",
    margin: "auto",
  },
  subTitle: {
    padding: "0px 30px 0px 30px",
    textAlign: "center",
    fontSize: 20,
  },
  loading: {
    // ensure the loading spinner is centered
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -20,
  },
  connectStoresDiv: {
    display: "inline-flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    justifyContent: "flex-start",
  },
  catalogsDiv: {
    padding: theme.spacing(1),
  },
  createCatalogButton: {
    marginBottom: theme.spacing(1),
  },
  paperPadding: {
    padding: theme.spacing(1),
  },
}));

function products(props) {
  const { classes } = useStyles();

  return (
    <div className={classes.fullPageHeight}>
      <CustomMeta
        title={`E-commerce Product Import | Create Marketing Posts from Etsy, WooCommerce & CSV`}
        description={`Import products from Etsy, WooCommerce, or a CSV file to generate social media posts across your connected platforms.`}
        url={`https://contentgenerator.io/products`}
      />
      <Typography variant="h1">Products</Typography>
      <Typography className={classes.subTitle}>
        Import your eCommerce products into Content Generator to generate better
        social media posts, faster.
      </Typography>

      {ExecutionEnvironment.canUseDOM && (
        <Suspense fallback={<div />}>
          <Grid container className={classes.root} spacing={2} direction="row">
            {props.user.loading ? (
              <CircularProgress className={classes.loading} size={25} />
            ) : props.user.authenticated ? (
              <Fragment>
                <Grid item xs={12} sm={12} md={6}>
                  <Paper className={classes.paperPadding}>
                    <Typography variant="h3">Add your shop</Typography>
                    <div className={classes.connectStoresDiv}>
                      <AddEtsyStore />
                      <AddWoocommerceStore />
                      <UploadProductsViaCSV />
                    </div>
                  </Paper>

                  {/* <UploadProducts /> */}
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <ConnectedShops />
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <ProductsTable />
                </Grid>
              </Fragment>
            ) : (
              <Fragment>
                <Grid item xs={12}>
                  <LoginOrSignup />
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <ProductsTable />
                </Grid>
              </Fragment>
            )}
          </Grid>
        </Suspense>
      )}
    </div>
  );
}

products.propTypes = {
  data: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  data: state.data,
  user: state.user,
  UI: state.UI,
});

export default connect(mapStateToProps, { getAffiliateData })(products);
